import React from "react";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import { rem } from "polished";

import { ReactComponent as TooltipIcon } from "../../assets/img/tooltip-icon.svg";

const TooltipSpan = styled.span`
  margin-left: ${rem(5)};
  align-self: center;
  width: ${rem(15)};
  height: ${rem(15)};
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
  }
`;

const Tooltip = ({ text }) => (
  <React.Fragment>
    <TooltipSpan data-tip={text}>
      <TooltipIcon />
    </TooltipSpan>

    <ReactTooltip effect="solid" />
  </React.Fragment>
);

export default Tooltip;
